// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as User_Context$DvmAdminFrontendFr from "../../../context/user/User_Context.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../intl/messages/Messages_Common.bs.js";
import * as App_Filter_Button$DvmAdminFrontendFr from "../../../common/components/button/App_Filter_Button.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../../common/styles/App_Styles_Common.bs.js";
import * as Company_Manage_Api$DvmAdminFrontendFr from "./Company_Manage_Api.bs.js";
import * as App_SelectFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_SelectFormInput.bs.js";
import * as Company_Manage_Form$DvmAdminFrontendFr from "./Company_Manage_Form.bs.js";
import * as App_CompanyFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_CompanyFormInput.bs.js";
import * as App_DebounceFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_DebounceFormInput.bs.js";
import * as Messages_Company_List$DvmAdminFrontendFr from "../../../intl/messages/company/Messages_Company_List.bs.js";
import * as App_DateInputFormField$DvmAdminFrontendFr from "../../../common/components/input/App_DateInputFormField.bs.js";
import * as App_TextFieldFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_TextFieldFormInput.bs.js";
import * as Messages_Company_Manage$DvmAdminFrontendFr from "../../../intl/messages/company/Messages_Company_Manage.bs.js";
import * as App_AutocompleteFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_AutocompleteFormInput.bs.js";

function Company_Manage_Filter(Props) {
  var fetchData = Props.fetchData;
  var fetchRequest = Props.fetchRequest;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var alert = ReactAlert.useAlert();
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var match$4 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setCities = match$4[1];
  var form = Company_Manage_Form$DvmAdminFrontendFr.TableFilterForm.useForm(Company_Manage_Form$DvmAdminFrontendFr.initialState, (function (param, submissionCallbacks) {
          Curry._2(fetchData, submissionCallbacks, {
                page: 0,
                rowsPerPage: fetchRequest.rowsPerPage,
                headers: fetchRequest.headers,
                filterQueryParams: Belt_Array.joinWith(Belt_List.toArray(Belt_List.keepMap({
                              hd: param.siret,
                              tl: {
                                hd: param.siren,
                                tl: {
                                  hd: param.name,
                                  tl: {
                                    hd: param.city,
                                    tl: {
                                      hd: param.endDate,
                                      tl: {
                                        hd: param.codeAPE,
                                        tl: {
                                          hd: param.hierarchy,
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }, (function (queryParam) {
                                return queryParam;
                              }))), ";", (function (queryParam) {
                        return queryParam;
                      })),
                additionalQueryParams: fetchRequest.additionalQueryParams
              });
        }));
  var callApi = function (filter) {
    Company_Manage_Api$DvmAdminFrontendFr.queryForSiretCities(alert, userManager, setCities, selectedRole, filter);
  };
  var tmp = {
    label: Messages_Common$DvmAdminFrontendFr.endDate,
    value: form.input.endDate,
    onChange: Curry._1(form.updateEndDate, (function (input, endDate) {
            return {
                    siret: input.siret,
                    siren: input.siren,
                    name: input.name,
                    city: input.city,
                    active: input.active,
                    endDate: endDate,
                    codeAPE: input.codeAPE,
                    hierarchy: input.hierarchy
                  };
          })),
    className: App_Styles_Common$DvmAdminFrontendFr.Inputs.standardInput
  };
  if (form.endDateResult !== undefined) {
    tmp.validationResult = Caml_option.valFromOption(form.endDateResult);
  }
  return React.createElement("form", {
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(Core.Grid, {
                  children: null,
                  className: App_Styles_Common$DvmAdminFrontendFr.Inputs.searchFiltersBox,
                  container: true
                }, React.createElement(Core.Grid, {
                      children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, {
                            onChange: Curry._1(form.updateName, (function (input, name) {
                                    return {
                                            siret: input.siret,
                                            siren: input.siren,
                                            name: name,
                                            city: input.city,
                                            active: input.active,
                                            endDate: input.endDate,
                                            codeAPE: input.codeAPE,
                                            hierarchy: input.hierarchy
                                          };
                                  })),
                            value: form.input.name,
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
                            label: Messages_Common$DvmAdminFrontendFr.companyName
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_CompanyFormInput$DvmAdminFrontendFr.make, {
                            onChange: (function (siret) {
                                Curry._2(form.updateSiret, (function (input, siret) {
                                        return {
                                                siret: siret,
                                                siren: input.siren,
                                                name: input.name,
                                                city: input.city,
                                                active: input.active,
                                                endDate: input.endDate,
                                                codeAPE: input.codeAPE,
                                                hierarchy: input.hierarchy
                                              };
                                      }), siret.trim());
                              }),
                            value: form.input.siret,
                            companies: match$3[0],
                            setCompanies: match$3[1],
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
                            companyType: "siret"
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_CompanyFormInput$DvmAdminFrontendFr.make, {
                            onChange: (function (siren) {
                                Curry._2(form.updateSiren, (function (input, siren) {
                                        return {
                                                siret: input.siret,
                                                siren: siren,
                                                name: input.name,
                                                city: input.city,
                                                active: input.active,
                                                endDate: input.endDate,
                                                codeAPE: input.codeAPE,
                                                hierarchy: input.hierarchy
                                              };
                                      }), siren.trim());
                              }),
                            value: form.input.siren,
                            companies: match$2[0],
                            setCompanies: match$2[1],
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
                            companyType: "siren"
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, {
                            onChange: Curry._1(form.updateCodeAPE, (function (input, codeAPE) {
                                    return {
                                            siret: input.siret,
                                            siren: input.siren,
                                            name: input.name,
                                            city: input.city,
                                            active: input.active,
                                            endDate: input.endDate,
                                            codeAPE: codeAPE,
                                            hierarchy: input.hierarchy
                                          };
                                  })),
                            value: form.input.codeAPE,
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.standardInput,
                            label: Messages_Company_Manage$DvmAdminFrontendFr.codeAPE
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_AutocompleteFormInput$DvmAdminFrontendFr.make, {
                            label: Messages_Company_Manage$DvmAdminFrontendFr.hierarchy,
                            value: {
                              TAG: /* Single */0,
                              _0: {
                                value: form.input.hierarchy,
                                onChange: Curry._1(form.updateHierarchy, (function (input, hierarchy) {
                                        return {
                                                siret: input.siret,
                                                siren: input.siren,
                                                name: input.name,
                                                city: input.city,
                                                active: input.active,
                                                endDate: input.endDate,
                                                codeAPE: input.codeAPE,
                                                hierarchy: hierarchy
                                              };
                                      }))
                              }
                            },
                            options: {
                              TAG: /* Labeled */1,
                              _0: {
                                hd: {
                                  label: {
                                    TAG: /* Message */0,
                                    _0: Messages_Company_Manage$DvmAdminFrontendFr.hierarchyOne
                                  },
                                  value: "1"
                                },
                                tl: {
                                  hd: {
                                    label: {
                                      TAG: /* Message */0,
                                      _0: Messages_Company_Manage$DvmAdminFrontendFr.hierarchyTwo
                                    },
                                    value: "2"
                                  },
                                  tl: {
                                    hd: {
                                      label: {
                                        TAG: /* Message */0,
                                        _0: Messages_Company_Manage$DvmAdminFrontendFr.hierarchyFromBCC
                                      },
                                      value: "9"
                                    },
                                    tl: /* [] */0
                                  }
                                }
                              }
                            },
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.standardInput
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_DebounceFormInput$DvmAdminFrontendFr.make, {
                            onChange: (function (city) {
                                Curry._2(form.updateCity, (function (input, city) {
                                        return {
                                                siret: input.siret,
                                                siren: input.siren,
                                                name: input.name,
                                                city: city,
                                                active: input.active,
                                                endDate: input.endDate,
                                                codeAPE: input.codeAPE,
                                                hierarchy: input.hierarchy
                                              };
                                      }), city.trim());
                              }),
                            value: form.input.city,
                            values: match$4[0],
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.standardInput,
                            callApi: callApi,
                            label: Messages_Common$DvmAdminFrontendFr.city,
                            debounceTriggerLength: 2
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_SelectFormInput$DvmAdminFrontendFr.make, {
                            label: Messages_Company_List$DvmAdminFrontendFr.active,
                            options: {
                              hd: {
                                label: {
                                  TAG: /* Message */0,
                                  _0: Messages_Common$DvmAdminFrontendFr.everything
                                },
                                value: ""
                              },
                              tl: {
                                hd: {
                                  label: {
                                    TAG: /* Message */0,
                                    _0: Messages_Common$DvmAdminFrontendFr.yes
                                  },
                                  value: "TRUE"
                                },
                                tl: {
                                  hd: {
                                    label: {
                                      TAG: /* Message */0,
                                      _0: Messages_Common$DvmAdminFrontendFr.no
                                    },
                                    value: "FALSE"
                                  },
                                  tl: /* [] */0
                                }
                              }
                            },
                            value: {
                              TAG: /* Single */0,
                              _0: {
                                value: form.input.active,
                                onChange: Curry._1(form.updateActive, (function (input, active) {
                                        return {
                                                siret: input.siret,
                                                siren: input.siren,
                                                name: input.name,
                                                city: input.city,
                                                active: active,
                                                endDate: input.endDate,
                                                codeAPE: input.codeAPE,
                                                hierarchy: input.hierarchy
                                              };
                                      }))
                              }
                            },
                            id: "active",
                            className: App_Styles_Common$DvmAdminFrontendFr.Inputs.shortInput
                          }),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_DateInputFormField$DvmAdminFrontendFr.make, tmp),
                      item: true
                    }), React.createElement(Core.Grid, {
                      children: React.createElement(App_Filter_Button$DvmAdminFrontendFr.make, {
                            label: "OK",
                            type_: "submit"
                          }),
                      item: true
                    })));
}

var Form;

var Api;

var InputStyles;

var make = Company_Manage_Filter;

export {
  Form ,
  Api ,
  InputStyles ,
  make ,
}
/* react Not a pure module */
